import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

// Components
import StatusTag from './tag/StatusTag'
import Text from './Text'
import Icon from './icon/Icon'
import { IconType } from './icon/IconType'

interface IAction {
  title?: string
  total: number
  complete: number
}

interface IProps {
  className?: string
  icon?: IconType
  actions: IAction[]
  darkerTags?: boolean
}

const GoalCount: React.FC<IProps> = ({
  className,
  actions,
  darkerTags,
  icon,
}) => {
  const themeContext = useContext(ThemeContext)
  return (
    <Container className={className}>
      {actions.map((action, index) => (
        <Action key={`requestAction-${index}`}>
          <StatusTag
            color={darkerTags ? 'textLightest' : 'lightest'}
            captionColor="text"
            caption={
              <Action>
                {icon && (
                  <Icon
                    type={icon}
                    size={16}
                    color={themeContext.colors.textLight}
                  />
                )}
                <Text
                  tag="span"
                  textStyle="labelHeavy"
                >{`${action.complete} / ${action.total}`}</Text>
              </Action>
            }
          />
          {action.title && (
            <Text marginLeft={6} textStyle="label">
              {action.title}
            </Text>
          )}
          {(action.complete === action.total ||
            action.complete > action.total) &&
            action.total !== 0 && (
              <CheckIcon
                size={12}
                type="Check"
                color={themeContext.colors.text}
              />
            )}
        </Action>
      ))}
    </Container>
  )
}

export default GoalCount

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`

const Action = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-of-type) {
    margin-right: 16px;
  }
`

export const CheckIcon = styled(Icon)`
  margin-left: 6px;
`
